<script>
import ParticipateButton from "@/components/2025/Buttons/ParticipateButton.vue";
import {mapGetters, mapState} from "vuex";

export default {
  name: "TournamentQualifierCard.vue",
  components: {
    ParticipateButton
  },
  props:{
    "title":{
      type: String,
      default: ""
    },
    "banner":{
      type: String,
      default: ""
    },
    "tournament": {
      type: Number,
      default: null
    }
  },
  data(){
    return {
      tournamentPhases: Object.freeze({
        REGISTRATION: 'REGISTRATION',
        CLOSED: 'CLOSED',
        TERMINATED: 'TERMINATED',
      }),
      currentPhase: "REGISTRATION",
      showPopUp: false,
      popUpOptions: {
        type: '',
        title: '',
        message: '',
      },
      TYPE_PLAYER: 1,
      TYPE_TEAM: 2,
      tournamentSize: null,
      tournamentRegistrationCounter: null,
      participationType: null,
    }
  },
  watch:{
    currentTournament: {
      handler(newTournament, oldTournament) {
        console.log('🎯 currentTournament changed:', newTournament)

        this.registrationCount();
        this.$forceUpdate()
      },
      deep: true,
      immediate: true    // run once upon component creation
    },
    tournamentsLoaded(newVal, oldVal) {
      if (newVal) {
        this.registrationCount();
      }
    },
  },
  computed:{
    ...mapGetters('subTournaments', ['getTournament']),
    ...mapState('subTournaments', {
      tournamentsLoaded: state => state.tournamentsLoaded,
      tournaments: state => state.tournaments,
    }),
    currentTournament(){
      return this.tournamentsLoaded ? this.tournaments[this.$route.name][this.tournamentId] : {size: 0};
    },
  },
  methods: {
    registrationCount(){
      const tournament = this.tournamentsLoaded ? this.getTournament(this.tournament, this.$route.name) : null;
      this.participationType = tournament?.settings.play_mode.size > 1 ? this.TYPE_TEAM : this.TYPE_PLAYER;
      this.tournamentSize = tournament && this.tournamentsLoaded ? tournament?.settings.size : 0;
      this.tournamentRegistrationCounter = this.participationType && this.tournamentsLoaded ?
          this.participationType == this.TYPE_TEAM ? tournament?.participants_teams.length : tournament?.participants_players.length : 0
    },
    initPopUp(options) {
      this.popUpOptions = options;
      this.showPopUp = true;
      console.log("trying to init pop up", this.popUpOptions)
      this.$emit('init-pop-up', this.popUpOptions);
    },
  }
}
</script>

<template>
  <div class="tournament-qualifier-card-wrapper w-100 h-100 position-relative"
       :style="{
          backgroundImage: `url(${banner})`,
       }"
  >
    <div class="tournament-qualifier-card d-flex flex-column justify-content-end align-items-end w-100 h-100 p-2">
      <div class="tournament-qualifier-card-content d-flex justify-content-md-between align-items-end w-100">
        <div>
          <h5 class="tournament-card-title text-uppercase text-white mb-2 mb-lg-0 m-lg-0" v-html="title"></h5>
        </div>
        <div class="tournament-registration-counter w-100">
          <p class="mb-2 mb-lg-0 text-white text-right text-uppercase"v-if="tournamentSize">{{tournamentRegistrationCounter}}/{{tournamentSize}}<br><span style="font-size: 10pt;">Registred</span></p>
        </div>
      </div>
      <div class="w-100">
        <div v-if="currentPhase === this.tournamentPhases.REGISTRATION">
          <div class="hero-section-btn-container w-100">
            <ParticipateButton class="w-100" data-toggle="modal" data-target="#lgame-participation-pop-up" @init-pop-up="initPopUp" :tournament-id="tournament"/>
          </div>
        </div>
        <div v-else-if="currentPhase === this.tournamentPhases.CLOSED">
          <div class="tournament-status terminated-phase px-4">
            <p class="m-0 label-closed">CLOSED</p> <!-- registration closed-->
          </div>
        </div>
        <div v-else>
          <div class="tournament-status terminated-phase px-4">
            <p class="m-0 label-finished">FINISHED</p> <!-- tournament finished-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.tournament-qualifier-card-wrapper{
  min-height: 240px;
  clip-path: polygon(0 0, calc(100% - 10px) 0, 100% 10px, 100% 100%, 10px 100%, 0 calc(100% - 10px));
  background-color: #121212;
  border-radius: 0 12px 0 12px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: left top;
}
.tournament-qualifier-card-wrapper:before{
  content: "";
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  z-index: -1;
  background: rgba(0,0,0,0.4);
  background: linear-gradient(0deg,rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.4) 40%, rgba(0, 0, 0, 0.15) 60%, rgba(0, 0, 0, 0) 100%);
}
.tournament-card-title{
  font-family: "sqwaredbold";
}
.tournament-status{
  clip-path: polygon(10px 0, 100% 0, 100% calc(100% - 10px), calc(100% - 10px) 100%, 0 100%, 0 10px);
  background: rgba(18, 18, 18, 0.6);
  font-family: "sqwaredsemi_bold";
  padding-top: 2px;
  padding-bottom: 2px;
}
.participate-phase{
  background: var(--main-color);
}
.participate-phase:hover{
  cursor: pointer;
  transform: scale(1.005);
}
.label-closed{
  color: rgba(255, 255, 255, 0.2);
}
.label-finished{
  color: #13980A;
}
.tournament-registration-counter{

}
.tournament-registration-counter p{
  font-family: "sqwaredsemi_bold";
  font-size: 10pt;
}
</style>